import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import SportCateDetail from './SportCateDetail'
import {channels , getACategory} from '../../graphqlDic';
import { graphql, compose } from 'react-apollo'
import {Link} from 'react-router-dom'
class SportCate extends Component {
  constructor(props){
    super(props);
    this.state= {
      category_id : 0,
      channel_id : 39,
      selected: "selected",
      limit:18,
      slug:''
    };
  }

  updateProp = (event) => {
    this.setState({
      channel_id: event.target.value,
      limit:18
    });
  }
  setPage = () =>{
      this.setState({
        limit:this.state.limit + 6
      })
  }
  componentWillMount() {
    if (!!this.props.getCategory.getCategory) {
            this.setState({
              category_id: this.props.getCategory.getCategory._id,
              slug:this.props.getCategory.getCategory.slug
            });
        }
    }

  componentWillReceiveProps(nextProps) {

    if (!!nextProps.getCategory.getCategory) {
        this.setState({
          category_id: nextProps.getCategory.getCategory._id,
          slug:nextProps.getCategory.getCategory.slug
          });
      }
  }
  render() {
    if (this.props.channels.loading) return "Loading...";
    if (this.props.channels.error) return `Error! ${this.props.channels.error.message}`;

    if (this.props.getCategory.loading) return "Loading...";
    if (this.props.getCategory.error) return `Error! ${this.props.getCategory.error.message}`;

    var channels = this.props.channels.channels;
    var category = this.props.getCategory.getCategory;
    var channel_option = channels.length > 0 ?  channels.map((channel,i) =>
            <Fragment key={i}>
            <option value={channel.id}>{channel.name}</option>
            </Fragment>
    ):"Không có dữ liệu";
    return (
       <Fragment>
          <div className="all-video">
                <div className="container">
                  <div className="clearfix top-control">
                      <div className="pull-left">
                        <ul className="breadcrumbs list-inline marginB0">
                            <li>
                            <Link to="/the-thao">Thể thao <span>/</span></Link>
                            </li>
                            <li className="active">{category.name}</li>
                        </ul>
                      </div>
                      <div className="pull-right">
                        <select onChange ={this.updateProp} className="slect">
                            {channel_option}
                        </select>
                      </div>
                    </div>
                      <SportCateDetail setPage={this.setPage} cate={this.state} />
                </div>
            </div>
        </Fragment>
    );
  }
}
// export default SportCate;
export default compose(
  graphql(channels,{name:'channels'}),
  graphql(getACategory,{name:'getCategory',
        options: (ownProps) => ({
          variables: {
              category_id: ownProps.match.params.id,
          }
      })
},
)
)(withRouter(
  connect(
    null
  )(SportCate)
))


// WEBPACK FOOTER //
// ./src/components/Sports/SportCate.js